import { produce } from "immer";
import {
  FETCH_TASK,
  FETCH_TASK_SUCCESS,
  FETCH_TASK_FAILURE,
  TOGGLE_TASK_MODAL,
} from "./constants";

export const initialState = {
  isFetchingTask: false,
  taskList: [],
  taskModal: {
    open: false,
    data: {},
  },
};

const TaskReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case FETCH_TASK:
        draft.isFetchingTask = true;
        draft.taskList = [];
        break;
      case FETCH_TASK_SUCCESS:
        draft.isFetchingTask = false;
        draft.taskList = action.payload;
        break;
      case FETCH_TASK_FAILURE:
        draft.isFetchingTask = false;
        draft.taskList = [];
        break;

      case TOGGLE_TASK_MODAL:
        draft.taskModal = action.payload;
        break;

      default:
        return state;
    }
  });

export default TaskReducer;
